import _ from 'lodash';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "../../../../global/cnr/reducers/reducerHelpers/dispatchProps";
import { getFirstObject } from '../../../../global/common/convert';
import { deleteFromObject, getGroupListData, removeFromObject } from '../../../../global/common/sorting';
import { sendMatchMessage } from "../../../sports/cnr/reducers/SportsDataReducer";
import { calcMatchStatus } from "../../golfCalcs/calcMatchStatus";
import { golfFixHelpers } from "./reducerHelpers/golfFix";
import { golfTournamentHelpers } from "./reducerHelpers/golfTournamentHelpers";

const removeFields_golferTournament = ['_itemKey', 'id', 'handicap', 'checked']

const deleteFields_golferTournament = [
  '_authId',
  '_existingKey',
  '_itemKey',
  'firstName',
  'handicapIndex',
  'handicapSourceType',
  'lastName',
  'name',
  'phoneNumber',
  'shortName',
  'teebox',
  'id',
  'key',
  '_authData',
  '_dateProps',
  '_updateDate',
  'auth_uid',
]

const _tournamentAllows = Object.freeze({
  allowAutoScoring: 'allowAutoScoring',
  allowNonAuthScoring: 'allowNonAuthScoring',
  allowTempAccess: 'allowTempAccess',
  matchCubeType: 'matchCubeType',
  showGolferHoleScoring: 'showGolferHoleScoring',
  showGolferTeamHoleScoring: 'showGolferTeamHoleScoring',
  tournamentIsActive: 'tournamentIsActive',
})


export const fields_golferTournament = ['courseHandicaps', 'courseTeeboxes', 'tournamentHandicapIndex', 'teamNumber', 'noTrueCourseHandicap']

export const rts = {
  handleAmmend_matchStartOrder: 'handleAmmend_matchStartOrder',
  handleAmmend_roundLineup: 'handleAmmend_roundLineup',
  handleAmmend_roundsDateAndTime: 'handleAmmend_roundsDateAndTime',
  handleAmmend_roundsList: 'handleAmmend_roundsList',
  handleAmmend_tempAppUserAccess: 'handleAmmend_tempAppUserAccess',
  handleArchive_tournament: 'handleArchive_tournament',
  handleChange_golferTeam: 'handleChange_golferTeam',
  handleChange_golferTournament: 'handleChange_golferTournament',
  handleCheck_eventGolfer: 'handleCheck_eventGolfer',
  handleClear_roundMatches: 'handleClear_roundMatches',
  handleClear_roundResults: 'handleClear_roundResults',
  handleClear_tournamentResults: 'handleClear_tournamentResults',
  handleCreate_roundMatches: 'handleCreate_roundMatches',
  handleFix_golfersTournament: 'handleFix_golfersTournament',
  handleFix_golfersTournamentHandicaps: 'handleFix_golfersTournamentHandicaps',
  handleFix_golfTournament: 'handleFix_golfTournament',
  handleFix_golfTournamentFromMatches: 'handleFix_golfTournamentFromMatches',
  handleGet_golfTournamentData: 'handleGet_golfTournamentData',
  handleGetSelectedTeamGolfers: 'handleGetSelectedTeamGolfers',
  handleGoTo_golfMatch: 'handleGoTo_golfMatch',
  handleGoTo_round: 'handleGoTo_round',
  handleLineup_init: 'handleLineup_init',
  handleLineup_select: 'handleLineup_select',
  handleLineup_update: 'handleLineup_update',
  handleReset_matches: 'handleReset_matches',
  handleResponse_lineupUpdated: 'handleResponse_lineupUpdated',
  handleSet_dataDetails: 'handleSet_dataDetails',
  handleSet_golfDataMatches: 'handleSet_golfDataMatches',
  handleSet_golferRoundMatches: 'handleSet_golferRoundMatches',
  handleSet_golfTournament: 'handleSet_golfTournament',
  handleSet_initGolfTournament: 'handleSet_initGolfTournament',
  handleSet_mainData: 'handleSet_mainData',
  handleSet_tournamentInfo: 'handleSet_tournamentInfo',
  handleShow_createArchive: 'handleShow_createArchive',
  handleShow_edit: 'handleShow_edit',
  handleShow_expandedMatches: 'handleShow_expandedMatches',
  handleShow_inlineCubes: 'handleShow_inlineCubes',
  handleShow_sortByTeam: 'handleShow_sortByTeam',
  handleShow_tournamentChart: 'handleShow_tournamentChart',
  handleShow_wizard: 'handleShow_wizard',
  handleStart_autoScoring: 'handleStart_autoScoring',
  handleUpdate_golfCourse: 'handleUpdate_golfCourse',
  handleUpdate_golfMatchHoleWinners: 'handleUpdate_golfMatchHoleWinners',
  handleUpdate_golfMatchScore: 'handleUpdate_golfMatchScore',
  handleUpdate_golfTournament: 'handleUpdate_golfTournament',
  handleUpdate_round: 'handleUpdate_round',
  handleUpdate_tournamentGolfer: 'handleUpdate_tournamentGolfer',
  handleUpdate_tournamentGolfersHandicaps: 'handleUpdate_tournamentGolfersHandicaps',
  handleUpdate_tournamentResults: 'handleUpdate_tournamentResults',
  ...grts,
}

export const golfTournamentReducer = (state, action) => {

  const { database_fns, navigation_fns, pathViews, golfTournament, golfEvent_state, golfers: golfers_tournament, matches: matches_state, autoScoringOn } = state
  const { golfCourses } = golfEvent_state ?? {}

  const { type, matchUpdate, roundKey, matches, dispatch } = action
  const { id: gtid } = golfTournament ?? {}

  // local handlers
  const _handlers = golfTournamentHandlers(dispatch)
  const { handleUpdate_golfCourse, handleSet_dataDetails, handleSet_mainData, handleSet_golfDataMatches, handleSet_tournamentInfo, handleResponse_lineupUpdated } = _handlers

  switch (type) {

    case rts.handleAmmend_tempAppUserAccess:
      return { ...state, tempAppUserAccess: action.tempAccess };

    case rts.handleAmmend_matchStartOrder:
      return { ...state, showCompletedMatchesLast: !state.showCompletedMatchesLast };

    case rts.handleShow_expandedMatches:
      return { ...state, showExpandedMatches: !state.showExpandedMatches };

    case rts.handleShow_inlineCubes:
      return { ...state, showInlineCubes: !state.showInlineCubes };

    case rts.handleShow_sortByTeam:
      return { ...state, showSortByTeam: !state.showSortByTeam };

    case rts.handleShow_wizard:
      return { ...state, showWizard: !state.showWizard, wizardOpts: action.wizardOpts };

    case rts.handleCheck_eventGolfer:
      const { item } = action
      const cg = item._itemKey === state.checkedGolfer ? null : item._itemKey
      return { ...state, checkedGolfer: cg }

    case rts.handleGet_golfTournamentData:
      if (action.golfTournamentKey) {
        pathViews.golfTournaments = action.golfTournamentKey
      }
      const gte = null // golfTournaments?.[action.golfTournamentKey]
      const callbacks = {
        main: handleSet_mainData,
        details: handleSet_dataDetails,
        matches: handleSet_golfDataMatches,
        info: handleSet_tournamentInfo,
        all: handleSet_mainData,
      }
      golfTournamentHelpers.getGolfTournamentWithDetails(database_fns, pathViews.golfTournaments, pathViews, callbacks, gte)
      return state

    case rts.handleSet_initGolfTournament:
      // this will update with any of the cuore tournament changes
      const a = golfTournamentHelpers.initGolfTournamentData(state, golfEvent_state)
      const tournamentGolfCourses = golfTournamentHelpers.getTournamentCourses(state)
      const p = {
        ...state,
        ...a,
        tournamentGolfCourses
      }
      return { ...p }

    case rts.handleSet_golfDataMatches:
      // this will update with any of the matches change 
      const tss = golfTournamentHelpers.ammendTournament_matchesStatus(state, action.matches)
      // console.log('state', state)
      return {
        ...state,
        matches: action.matches,
        tournamentStatus: tss.ts,
        roundsStatus: tss.roundsStatus,
        matches_rounds: tss.matches_rounds,
        matches_golfTournament: tss.matches_golfTournament
      }

    case rts.handleSet_tournamentInfo:
      return { ...state, info: action.info }

    // case rts.handleSet_mainData:
    //   const { results: mainData } = action  
    //   const { golfCourse: gc_m, golfers: golfers_m } = mainData ?? {}

    //   let tgc;

    //   if (gc_m) {
    //     if (golfCourses && golfCourses[gc_m]) {
    //       tgc = golfCourses[gc_m]
    //     } else {
    //       database_fns.get_data_any({ pathViews, collectionName: 'golfCourses', callback: handleUpdate_golfCourse, opts: { docKey: mainData.golfCourse, clientPath: true } })
    //     }
    //   }

    //   let playersPerTeam = 2

    //   if (golfers_m) {
    //     const totalGolfers = Object.keys(golfers_m).length
    //     playersPerTeam = totalGolfers / 2
    //     mainData.playersPerTeam = playersPerTeam

    //     Object.keys(v).forEach(key => {
    //       if (v[key].teamNumber) {
    //         golfers_m[key].teamNumber = parseInt(golfers_m[key].teamNumber)
    //         golfers_m[key].key = key
    //       }
    //     })
    //   }
    //   return { ...state, tournament: mainData }

    case rts.handleSet_dataDetails:
      const { detailsData } = action
      const { mainData: t, details: d, _details: dd } = detailsData ? detailsData : {}
      const { golfers } = d ? d : {}

      let tgc;

      if (t && t.golfCourse) {
        if (golfCourses && golfCourses[t.golfCourse]) {
          tgc = golfCourses[t.golfCourse]
        } else {
          database_fns.get_data_any({ pathViews, collectionName: 'golfCourses', callback: handleUpdate_golfCourse, opts: { docKey: t.golfCourse, clientPath: true } })
        }
      }

      let playersPerTeam = 2

      if (golfers) {
        const totalGolfers = Object.keys(golfers).length
        playersPerTeam = totalGolfers / 2
        t.playersPerTeam = playersPerTeam

        Object.keys(golfers).forEach(key => {
          if (golfers[key].teamNumber) {
            golfers[key].teamNumber = parseInt(golfers[key].teamNumber)
            golfers[key].key = key
          }
        })
      }
      return { ...state, details: d, golfTournament: t, _details: dd, golfCourse: tgc }

    case rts.handleCreate_roundMatches:
      golfTournamentHelpers.createRoundMatchesInDatabase(database_fns, gtid, pathViews, matches, roundKey, action.callback, action.testOnly)
      return state

    case rts.handleClear_tournamentResults:
      // database_fns, gtid, golfTournament, pathViews, callback
      golfTournamentHelpers.clearTournamentResultsInDatabase(database_fns, gtid, golfTournament, pathViews, action.callback)

    case rts.handleClear_roundResults:
      golfTournamentHelpers.clearRoundResultsInDatabase(database_fns, gtid, pathViews, action.roundKey, action.matches_round, action.callback)
      return state

    case rts.handleClear_roundMatches:
      golfTournamentHelpers.clearRoundMatchesInDatabase(database_fns, gtid, pathViews, action.roundKey, action.callback)
      return state

    case rts.handleUpdate_tournamentGolfer:
      const { golfer: _golfer } = action
      const { _itemKey } = _golfer
      if (_itemKey) {
        removeFromObject(_golfer, removeFields_golferTournament)
        deleteFromObject(_golfer, deleteFields_golferTournament)
        const dtu = {
          golfers: {
            [_itemKey]: _golfer
          }
        }
        golfTournamentHelpers.updateGolfTournamentDetails(database_fns, gtid, pathViews, { ...dtu }, action.callback)
      }
      return state

    case rts.handleUpdate_tournamentGolfersHandicaps:
      const _golfers = _.cloneDeep(action.golfers)
      Object.keys(_golfers).forEach(k => {
        const g = _golfers[k]
        removeFromObject(g, removeFields_golferTournament)
        deleteFromObject(g, deleteFields_golferTournament)
      })
      const dtua = { golfers: _golfers }
      golfTournamentHelpers.updateGolfTournamentDetails(database_fns, gtid, pathViews, dtua, action.callback)
      return state

    case rts.handleLineup_update:
      const gtlu = { ['lineups.' + action.teamKey + '.' + action.roundType]: action.lineup }
      golfTournamentHelpers.updateGolfTournamentDetails(database_fns, gtid, pathViews, gtlu, handleResponse_lineupUpdated)
      return { ...state, cb_action: action.callback }

    case rts.handleResponse_lineupUpdated:
      if (state.cb_action) { state.cb_action() }
      return { ...state, updating: false }

    case rts.handleUpdate_round:
      const gtlx = { ['rounds.' + action.roundType + '.golfCourse']: action.selectedCourse }
      console.log('gtlx', gtlx)
      console.log('gtlx', gtlx)
      // golfTournamentHelpers.updateGolfTournamentDetails(gtid, pathViews, gtlx, action.callback)
      return state

    case rts.handleChange_golferTournament:
      const { lineups: lineups_changed, golfers: golfer_changed } = changeTournanemtGolfer(action, state)
      golfTournamentHelpers.updateGolfTournamentDetails(database_fns, gtid, pathViews, { 'golfers': golfer_changed, 'lineups': lineups_changed }, action.callback)
      return state

    case rts.handleUpdate_tournamentResults:
      const { tournamentStatus, roundsStatus, golfCourse, golfTeam1, golfTeam2, golfStyles } = state
      const { team1Points, team1Wins, team1Halved, team2Points, team2Wins, team2Halved } = tournamentStatus ?? {}
      const { golfTeam1Style, golfTeam2Style } = golfStyles ?? {}

      const _roundsStatus = {}

      _.forEach(roundsStatus, (rs, rsk) => {
        const { team1Points, team2Points } = rs ?? {}
        _roundsStatus[rsk] = { team1Points, team2Points }
      })

      const dataToUpate = {
        results: {
          team1Points,
          team1Wins,
          team1Halved,
          team2Points,
          team2Wins,
          team2Halved,
          golfCourseName: golfCourse?.name,
          teamName1: golfTeam1?.name,
          teamName2: golfTeam2?.name,
          golfTeam1Style,
          golfTeam2Style,
          roundsStatus: _roundsStatus
        }
      }
      golfTournamentHelpers.updateGolfTournamentResults(database_fns, gtid, pathViews, dataToUpate)
      return state

    case rts.handleSet_golfTournament:
      return {
        golfTournaments: action.gt,
        ...state,
      }


    case rts.handleSet_golferRoundMatches:
      const { golferRecords, golferRecordsSorted } = golfTournamentHelpers.getGolferResults(state)
      return { ...state, golferMatches: action.golferMatches, golferRecords, golferRecordsSorted }

    case rts.handleUpdate_golfCourse:
      const { item: gc } = getFirstObject(action.golfCourse)
      return { ...state, golfCourse: gc }

    case rts.handleGoTo_round:
      navigation_fns.handleNav_item({ key: 'tournamentRounds' }, roundKey)
      return state

    case rts.handleGoTo_golfMatch:
      navigation_fns.handleNav_item({ key: 'golfMatches' }, action.gm._itemKey)
      return state

    case rts.handleLineup_init:
      const _selectedKeys = []
      const { lineupInfo } = action
      const { teamRoundLineup, golfers_lineup, golfers_team } = lineupInfo ? lineupInfo : {}
      if (teamRoundLineup) {
        teamRoundLineup.forEach(g => {
          _selectedKeys.push(g.golferKey)
        })
        const _golfers = golfTournamentHelpers.getSeletedTeamGolfers(_selectedKeys, golfers_lineup, golfers_team)
        const _sorted = _golfers ? getGroupListData(_golfers, null, 2, 'group') : {}
        return { ...state, lineupInfo: { roundLineup: teamRoundLineup, selectedKeys: _selectedKeys, golfers: _golfers, sorted: _sorted }, selectedLineupItems: _selectedKeys }
      }
      return { ...state, lineupInfo: {} }

    case rts.handleLineup_select:
      const _lineupInfo = { ...state.lineupInfo }
      const { selectedGolferKeys } = action
      const _roundLineup = _.filter(golfers_tournament, (golfer, key) => _.includes(selectedGolferKeys, key));
      _lineupInfo.selectedKeys = selectedGolferKeys
      _lineupInfo.roundLineup = _roundLineup;
      return { ...state, lineupInfo: _lineupInfo }

    case rts.handleAmmend_roundLineup:
      const _lineupInfo2 = { ...state.lineupInfo }
      _lineupInfo2.roundLineup = action.round_lineup
      return { ...state, lineupInfo: _lineupInfo2 }

    case rts.handleUpdate_golfMatchHoleWinners:
      const { golfMatch: _gm } = matchUpdate
      const _matchData = { ..._gm }
      golfTournamentHelpers.updateMatchScore(database_fns, pathViews.golfTournaments, pathViews, _matchData, action.callback)
      return state

    case rts.handleUpdate_golfTournament:
      golfTournamentHelpers.updateGolfTournament(database_fns, gtid, pathViews, action.details, action.callback)
      return { ...state };

    case rts.handleUpdate_golfMatchScore:

      // this will update the match score

      const { golfMatch, holeNumber, winningTeam, winningGolfer, playerScoring } = matchUpdate
      const matchData = { ...golfMatch }

      // create holeWinners if it does not exist
      if (!matchData.holeWinners) { matchData.holeWinners = {} }
      matchData.holeNumber = holeNumber

      // update holeWinners
      switch (winningTeam) {
        case -1:
          // REMOVE the score
          golfTournamentHelpers.removeMatchScore(database_fns, pathViews.golfTournaments, pathViews, matchData, holeNumber, action.callback)
          break;

        default:
          if (playerScoring) {
            // update the player; scores
            if (!matchData.holeScores) { matchData.holeScores = {} }
            let _playerScoring = {}
            if (playerScoring.team1) { _playerScoring = { ...playerScoring.team1 } }
            if (playerScoring.team2) { _playerScoring = { ..._playerScoring, ...playerScoring.team2 } }
            matchData.holeScores[holeNumber] = _playerScoring
          }
          const count = Object.keys(matchData.holeWinners).length

          matchData.holeWinners[holeNumber] = {
            winningTeam: winningTeam,
            order: count,
            // createdAt: serverTimestamp(),
            createdAt: Date.now()
          }

          if (winningGolfer) {
            matchData.holeWinners[holeNumber].winningGolfer = winningGolfer
          }

          // const activeHoleNumber = _.last(_.keys(matchData.holeWinners))
          // console.log('holeNumber', matchData._itemKey, holeNumber, activeHoleNumber)

          try {
            const { matchStatus } = action
            let _holeResult;
            if (winningTeam > 0) {
              const _team = state.teams ? _.find(state.teams, { teamNumber: winningTeam }) : {}
              const { name: name_winningTeam } = _team ? _team : {}
              if (name_winningTeam) {
                _holeResult = name_winningTeam + ' has won hole #' + holeNumber + '.'
              } else {
                _holeResult = winningTeam + ' has won hole #' + holeNumber + '.'
              }
            } else {
              _holeResult = 'Hole # ' + holeNumber + ' was tied.'
            }
            const _matchStatus = calcMatchStatus(matchData, state.holes, state.teams, null, null, matchStatus)
            sendMatchMessage(_matchStatus, _holeResult)
          } catch (error) {

          }

          if (autoScoringOn) {
            const _matches_state = _.cloneDeep(matches_state)
            if (_matches_state?.[matchData?.round]?.[matchData?.id]) {
              _matches_state[matchData?.round][matchData.id] = matchData
              action.callback()
              return { ...state, matches: _matches_state }
            }
          } else {
            golfTournamentHelpers.updateMatchScore(database_fns, pathViews.golfTournaments, pathViews, matchData, action.callback)
          }
      }

      return state

    case rts.handleReset_matches:
      const _matches = _.cloneDeep(state?.matches)
      const _roundMatches = _.cloneDeep(_matches[action.roundKey])
      _.forEach(_roundMatches, (m) => {
        delete m.holeWinners
      })
      _matches[action.roundKey] = _roundMatches; // 👈 reassign back
      return { ...state, matches: _matches }


    case rts.handleChange_golferTeam:
      const { tournamentGolfers } = state
      const { player, teamIndex, rowIndex } = action
      const { key: playerKey } = player ? player : {}
      const tgp = tournamentGolfers[playerKey]
      tgp.teamNumber = teamIndex
      return { ...state, tournamentGolfers, rowIndex }

    case rts.handleFix_golfTournament:
      golfFixHelpers.fixTournament(state)
      return state

    case rts.handleFix_golfTournamentFromMatches:
      golfFixHelpers.fixFromMatches(state)
      return state

    case rts.handleFix_golfersTournamentHandicaps:
      golfFixHelpers.fixGolferHandicaps(state)
      return state

    case rts.handleFix_golfersTournament:
      golfFixHelpers.fixGolfers_tournament(state)
      return state

    case rts.handleShow_edit:
      action.e && action.e.stopPropagation()
      return { ...state, showEdit: !state.showEdit }

    case rts.handleShow_createArchive:
      action.e && action.e.stopPropagation()
      return { ...state, showCreateArchive: !state.showCreateArchive }

    case rts.handleArchive_tournament:
      golfTournamentHelpers.archiveTournment(state)
      return { ...state, showCreateArchive: false }

    case rts.handleAmmend_roundsDateAndTime:
      const { round } = action
      const { startDate, startTime, key } = round;
      const updates_dt = {};
      updates_dt[`rounds.${key}.startDate`] = startDate;
      updates_dt[`rounds.${key}.startTime`] = startTime;
      golfTournamentHelpers.updateGolfTournamentDetails(database_fns, gtid, pathViews, updates_dt, action.callback)
      return { ...state }

    case rts.handleAmmend_roundsList:
      const { roundsList } = action
      const updates = {};
      roundsList.forEach((round, idx) => {
        const { roundNumber, key } = round;
        updates[`rounds.${key}.roundNumber`] = roundNumber;
      });
      golfTournamentHelpers.updateGolfTournamentDetails(database_fns, gtid, pathViews, updates, action.callback)
      return { ...state }

    case rts.handleShow_tournamentChart:
      const _showRoundCharts = state.showRoundCharts ? state.showRoundCharts : {}
      _showRoundCharts[action.roundKey] = !_showRoundCharts[action.roundKey]
      return { ...state, showRoundCharts: _showRoundCharts }

    case rts.handleStart_autoScoring:

      let roundTimeline = null

      // if (state.autoScoringOn) {
      //   const _roundMatches = state?.matches?.[state.autoScoringRoundKey]
      //   roundTimeline = golfTournamentHelpers.getHoleWinnerTimeline(_roundMatches)
      // }

      return { ...state, autoScoringOn: !state.autoScoringOn, autoScoringRoundKey: action.roundKey, roundTimeline }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse: s
    case rts.handleStartUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation })

    default:
      return state
  }
}

export const golfTournamentHandlers = (dispatch) => {
  return {
    handleAmmend_matchStartOrder: () => { dispatch({ type: rts.handleAmmend_matchStartOrder, dispatch }) },
    handleAmmend_roundLineup: (round_lineup) => { dispatch({ type: rts.handleAmmend_roundLineup, dispatch, round_lineup }) },
    handleAmmend_roundsDateAndTime: (round, callback) => { dispatch({ type: rts.handleAmmend_roundsDateAndTime, round, callback }) },
    handleAmmend_roundsList: (roundsList, callback) => { dispatch({ type: rts.handleAmmend_roundsList, roundsList, callback }) },
    handleAmmend_tempAppUserAccess: (tempAccess) => { dispatch({ type: rts.handleAmmend_tempAppUserAccess, tempAccess }) },
    handleArchive_tournament: () => { dispatch({ type: rts.handleArchive_tournament }) },
    handleChange_golferTeam: (player, teamIndex, rowIndex) => { dispatch({ type: rts.handleChange_golferTeam, player, teamIndex, rowIndex }) },
    handleChange_golferTournament: (existingGolferKey, newGolfer) => { dispatch({ type: rts.handleChange_golferTournament, existingGolferKey, newGolfer }) },
    handleCheck_eventGolfer: (e, item, itemChecked) => { dispatch({ type: rts.handleCheck_eventGolfer, dispatch, e, item, itemChecked }) },
    handleClear_roundMatches: (roundKey, callback) => { dispatch({ type: rts.handleClear_roundMatches, dispatch, roundKey, callback }) },
    handleClear_roundResults: (matches_round, roundKey, callback) => { dispatch({ type: rts.handleClear_roundResults, dispatch, matches_round, roundKey, callback }) },
    handleClear_tournamentResults: (callback) => { dispatch({ type: rts.handleClear_tournamentResults, dispatch, callback }) },
    handleCreate_roundMatches: (matches, roundKey, callback, testOnly) => { dispatch({ type: rts.handleCreate_roundMatches, dispatch, matches, roundKey, callback, testOnly }) },
    handleFix_golfersTournament: () => { dispatch({ type: rts.handleFix_golfersTournament, dispatch }) },
    handleFix_golfersTournamentHandicaps: () => { dispatch({ type: rts.handleFix_golfersTournamentHandicaps, dispatch }) },
    handleFix_golfTournament: () => { dispatch({ type: rts.handleFix_golfTournament, dispatch }) },
    handleFix_golfTournamentFromMatches: () => { dispatch({ type: rts.handleFix_golfTournamentFromMatches, dispatch }) },
    handleGet_golfTournamentData: (existing, golfTournamentKey) => { dispatch({ type: rts.handleGet_golfTournamentData, dispatch, existing, golfTournamentKey }) },
    handleGoTo_golfMatch: (gm) => { dispatch({ type: rts.handleGoTo_golfMatch, gm }) },
    handleGoTo_round: (roundKey) => { dispatch({ type: rts.handleGoTo_round, roundKey }) },
    handleLineup_init: (lineupInfo) => { dispatch({ type: rts.handleLineup_init, dispatch, lineupInfo }) },
    handleLineup_select: (selectedGolferKeys) => { dispatch({ type: rts.handleLineup_select, dispatch, selectedGolferKeys }) },
    handleLineup_update: (teamKey, roundType, lineup, callback) => { dispatch({ type: rts.handleLineup_update, dispatch, teamKey, roundType, lineup, callback }) },
    handleReset_matches: (roundKey) => { dispatch({ type: rts.handleReset_matches, dispatch, roundKey }) },
    handleResponse_lineupUpdated: () => { dispatch({ type: rts.handleResponse_lineupUpdated, dispatch }) },
    handleSet_dataDetails: (detailsData) => { dispatch({ type: rts.handleSet_dataDetails, detailsData, dispatch }) },
    handleSet_golfDataMatches: (matches) => { dispatch({ type: rts.handleSet_golfDataMatches, matches, dispatch }) },
    handleSet_golferRoundMatches: () => { dispatch({ type: rts.handleSet_golferRoundMatches }) },
    handleSet_golfTournament: (gt) => { dispatch({ type: rts.handleSet_golfTournament, dispatch, gt }) },
    handleSet_initGolfTournament: () => { dispatch({ type: rts.handleSet_initGolfTournament }) },
    handleSet_mainData: (results) => { dispatch({ type: rts.handleSet_mainData, results, dispatch }) },
    handleSet_tournamentInfo: (info) => { dispatch({ type: rts.handleSet_tournamentInfo, info, dispatch }) },
    handleShow_createArchive: (e) => { dispatch({ type: rts.handleShow_createArchive, dispatch, e }) },
    handleShow_edit: (e) => { dispatch({ type: rts.handleShow_edit, dispatch, e }) },
    handleShow_expandedMatches: () => { dispatch({ type: rts.handleShow_expandedMatches, dispatch }) },
    handleShow_inlineCubes: () => { dispatch({ type: rts.handleShow_inlineCubes, dispatch }) },
    handleShow_sortByTeam: () => { dispatch({ type: rts.handleShow_sortByTeam, dispatch }) },
    handleShow_tournamentChart: (roundKey) => { dispatch({ type: rts.handleShow_tournamentChart, roundKey }) },
    handleShow_wizard: (wizardOpts) => { dispatch({ type: rts.handleShow_wizard, dispatch, wizardOpts }) },
    handleStart_autoScoring: (roundKey) => { dispatch({ type: rts.handleStart_autoScoring, roundKey }) },
    handleUpdate_golfCourse: (golfCourse) => { dispatch({ type: rts.handleUpdate_golfCourse, golfCourse, dispatch }) },
    handleUpdate_golfMatchHoleWinners: (matchUpdate, callback) => { dispatch({ type: rts.handleUpdate_golfMatchHoleWinners, matchUpdate, callback, dispatch }) },
    handleUpdate_golfMatchScore: (matchUpdate, callback, matchStatus) => { dispatch({ type: rts.handleUpdate_golfMatchScore, matchUpdate, matchStatus, callback, dispatch }) },
    handleUpdate_golfTournament: (details, callback) => { dispatch({ type: rts.handleUpdate_golfTournament, dispatch, details, callback }) },
    handleUpdate_round: (roundType, selectedCourse, callback) => { dispatch({ type: rts.handleUpdate_round, dispatch, roundType, selectedCourse, callback }) },
    handleUpdate_tournamentGolfer: (golfer) => { dispatch({ type: rts.handleUpdate_tournamentGolfer, golfer, dispatch }) },
    handleUpdate_tournamentGolfersHandicaps: (golfers, callback) => { dispatch({ type: rts.handleUpdate_tournamentGolfersHandicaps, golfers, callback }) },
    handleUpdate_tournamentResults: () => { dispatch({ type: rts.handleUpdate_tournamentResults }) },
    ...responseHandlers(dispatch)
  }
}

export const golfTournamentInitialState = (init_state) => {
  return {
    ...init_state,
    _propAllows: _tournamentAllows
  }
};